// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-charts-insights {
  max-height: 80vh;
  max-width: 300px;
  overflow: auto;
  padding: var(--g-spacing-4);
}
.chartkit-charts-insights__tooltip:not(:first-child) {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--g-color-line-generic);
}
.chartkit-charts-insights__tooltip-title {
  display: flex;
  align-items: center;
  font-weight: bold;
}
.chartkit-charts-insights__tooltip-icon {
  margin-right: 8px;
}
.chartkit-charts-insights__tooltip-button {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/ChartKitBase/components/Header/components/ChartsInsights/components/TooltipContent/TooltipContent.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,2BAAA;AACJ;AACI;EACI,gBAAA;EACA,iBAAA;EACA,iDAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAAR;AAGI;EACI,iBAAA;AADR;AAII;EACI,eAAA;AAFR","sourcesContent":[".chartkit-charts-insights {\n  max-height: 80vh;\n  max-width: 300px;\n  overflow: auto;\n  padding: var(--g-spacing-4);\n}\n.chartkit-charts-insights__tooltip:not(:first-child) {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--g-color-line-generic);\n}\n.chartkit-charts-insights__tooltip-title {\n  display: flex;\n  align-items: center;\n  font-weight: bold;\n}\n.chartkit-charts-insights__tooltip-icon {\n  margin-right: 8px;\n}\n.chartkit-charts-insights__tooltip-button {\n  margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
